<script lang="ts">
  export let text: string;
</script>

<div
  class="py-0.5 px-2.5 text-sm text-gray-700 font-medium bg-gray-50 border border-gray-200 rounded-xxl w-max"
>
  {text}
</div>
